import React from 'react';
import { NavigateMapContainer } from '../navigateStyles';
import { IonButton } from '@ionic/react';
import SingleTrailMap from '../../../MapComponents/SingleTrailMap';
import { Trail } from '../../../../models/Trail';
import SingleTrailNavigator from '../../../MapComponents/SingleTrailNavigator';

type NavigateMapProps = {
	setIsToastOpen: React.Dispatch<React.SetStateAction<any>>;
	trail: Trail;
};

const NavigateMap: React.FC<NavigateMapProps> = ({ setIsToastOpen, trail }) => {
	return (
		<NavigateMapContainer>
			<SingleTrailNavigator trail={trail} />
			{/*<div className="flex">*/}
			{/*	<IonButton onClick={() => setIsToastOpen(true)}>*/}
			{/*		Open Toast*/}
			{/*	</IonButton>*/}
			{/*	<IonButton onClick={() => setIsToastOpen(false)}>*/}
			{/*		Close Toast*/}
			{/*	</IonButton>*/}
			{/*</div>*/}
		</NavigateMapContainer>
	);
};

export default NavigateMap;
